var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGrayVoiceIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 17,
  viewBox: "0 0 21 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 5.06445,
  r: 3.25,
  stroke: "#999999",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.7676 6.43104C15.7177 5.45177 15.7189 3.8768 14.7676 2.89551",
  stroke: "#999999",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 7.43592C19.6126 5.77394 19.6146 3.10096 18 1.43555",
  stroke: "#999999",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 16.5645V14.0645C1 12.4076 2.34315 11.0645 4 11.0645H13C14.6569 11.0645 16 12.4076 16 14.0645V16.5645",
  stroke: "#999999",
  strokeWidth: 1.5
})));
export default SvgGrayVoiceIcon;